import _ from 'lodash';

const checkDoShowSavePassenger = (passengers, passenger, passengerIndexByRoom,
  disabledPassengerInfo, isLoggedIn, travelAgency, loggedInUserEmail) => {
  if (!travelAgency) return false;
  // if settings don't exist, we still may want to show the checkbox
  // (not every agency has settings object)
  if (travelAgency.settings && !travelAgency.settings.doAllowSavingTravelerInfo) return false;
  if (disabledPassengerInfo || !isLoggedIn) return false;
  if (passenger.roomIndex === 0 && passengerIndexByRoom === 0) return true;
  if (passenger.roomIndex !== 0 && passengerIndexByRoom === 0
       && !passenger.contactEmail) return true;
  if (!passenger.contactEmail) return false;

  const filteredPassengers = _.filter(passengers, (p) => (p.contactEmail || '').toLowerCase() === (passenger.contactEmail || '').toLowerCase());

  // If only one passenger with this email, show checkbox
  if (filteredPassengers.length <= 1) return true;

  // If agency allows creating clients by person info AND email matches logged-in user:
  // Check if names are different from other passengers with same email
  if (travelAgency.doAllowAgentsCreateClientsByPersonInfo && loggedInUserEmail
      && (passenger.contactEmail || '').toLowerCase() === loggedInUserEmail.toLowerCase()) {
    const currentPassengerName = [
      passenger.firstName || '',
      passenger.middleName || '',
      passenger.lastName || '',
    ].join('').toLowerCase().trim();

    // If current passenger has different name from others with same email, show checkbox
    const hasDifferentName = filteredPassengers.every((p) => {
      if (p.passengerIndex === passenger.passengerIndex) return true;
      const otherPassengerName = [
        p.firstName || '',
        p.middleName || '',
        p.lastName || '',
      ].join('').toLowerCase().trim();
      return currentPassengerName !== otherPassengerName;
    });

    return hasDifferentName;
  }

  // If this is the first passenger with this email (and not logged-in user email), show checkbox
  if (filteredPassengers[0].passengerIndex === passenger.passengerIndex) return true;

  return false;
};

export default checkDoShowSavePassenger;
